
let config = {
    key: 'xhszp',
    encryption: 'bf'
}
export { config }


// WEBPACK FOOTER //
// ./src/views/encryptionConfig.js